module.exports = function() {
  return new Worker(__webpack_public_path__ + "21b44583a4b87703a07f.worker.js");
};